import Container from "./Container";
import { useGetInvestorProfile, useGetInvestorProfileInsights } from "../api/investor-profile-api";
import Show from "./Show";
import Text from "./Text";
import { Button } from "primereact/button";
import Divider from "./Divider";
import InsightItem from "./InsightItem";
import { useMemo } from "react";
import { Tracker } from "../analytics";

export default function InsightsContent({ setInvestorProfileOpen }: { setInvestorProfileOpen: (isOpen: boolean) => void }) {
    const investorProfileQuery = useGetInvestorProfile();
    const investorProfileInsightsQuery = useGetInvestorProfileInsights();

    const riskLevel = useMemo(() => {
        const risk = investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.risco?.nivel;

        if (!risk) {
            return "";
        }

        return risk.slice(0, 1).toUpperCase() + risk.slice(1).toLowerCase();
    }, [investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.risco?.nivel]);

    return (
        <Container flexColumn gap={4} fullWidth>
            <Show when={investorProfileQuery.isLoading}>
                <Container>
                    <Text>Carregando...</Text>
                </Container>
            </Show>

            <Show when={investorProfileQuery.isError || !investorProfileQuery.data?.profile}>
                <Container flexColumn gap={2}>
                    <Text size="4xl" center>⚠️</Text>
                    <Text color="900" className="text-center text-2xl font-bold">Perfil do investidor incompleto</Text>
                    <Text className="text-center text-lg font-light text-gray-600">Preencha seu perfil para visualizar insights da carteira</Text>

                    <Button
                        onClick={() => {
                            Tracker.trackCta('register_investor_profile', '/insights');
                            setInvestorProfileOpen(true);
                        }}
                        className="justify-content-center mt-2"
                    >
                        Cadastrar perfil
                    </Button>
                </Container>
            </Show>

            <Show when={!!investorProfileQuery.data?.profile && !investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight}>
                <Container flexColumn gap={2}>
                    <Text size="4xl" center>⚠️</Text>
                    <Text color="900" className="text-center text-2xl font-bold">Pendente de análise</Text>
                    <Text className="text-center text-lg font-light text-gray-600">Seu perfil de investidor já foi cadastrado, mas ainda não foi realizada a análise</Text>
                </Container>
            </Show>

            <Show when={!!investorProfileQuery.data?.profile && !!investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight}>
                <InsightItem title="🔔 Aviso">
                    {investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.aviso}
                </InsightItem>
                <Divider />
                
                <InsightItem title="🟡 Status">
                    {investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.status}
                </InsightItem>
                <Divider />

                <InsightItem title="🔥 Risco">
                    {riskLevel}
                </InsightItem>
                <Divider />

                <InsightItem title="💧 Liquidez">
                    {investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.liquidez?.comentario}
                </InsightItem>
                <Divider />

                <InsightItem title="🌐 Diversificação">
                    {investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.diversificacao?.comentario}
                </InsightItem>
                <Divider />

                <InsightItem title="💡 Insight Educativo">
                    {investorProfileInsightsQuery.data?.portfolio_insight?.openai_insight?.insight_educativo}
                </InsightItem>
            </Show>
        </Container>
    )
}